import { render, staticRenderFns } from "./Navbar.vue?vue&type=template&id=0bbc27d4&scoped=true&"
import script from "./Navbar.vue?vue&type=script&lang=js&"
export * from "./Navbar.vue?vue&type=script&lang=js&"
import style0 from "./Navbar.vue?vue&type=style&index=0&id=0bbc27d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbc27d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/nisems/front/nisbos-front-admin/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bbc27d4')) {
      api.createRecord('0bbc27d4', component.options)
    } else {
      api.reload('0bbc27d4', component.options)
    }
    module.hot.accept("./Navbar.vue?vue&type=template&id=0bbc27d4&scoped=true&", function () {
      api.rerender('0bbc27d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Layout/components/Navbar.vue"
export default component.exports